import { RouteConfig } from "vue-router";

export const REmployerCompanySponsorLicence: RouteConfig = {
  path: "sponsor_licence",
  name: "EmployerCompanySponsorLicence",
  component: () =>
    import(
      /* webpackChunkName: "employer-company-sponsor_licence" */
      "./VEmployerCompanySponsorLicence.vue"
    ),
  meta: {
    title: "Company",
    label: "sponsor licence",
    tabName: "sponsor_licence",
    alias: "sponsor_licence",
  },
};
